module.exports = __webpack_public_path__ + "img/bg.ef18c38f.jpg";